import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DistrictsService} from "../../../services/districts.service";
import {District} from "../../../interfaces/district";
import {Swiper, FreeMode, SwiperOptions} from "swiper";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {setJobFilter} from "../../../store/actions/filter.actions";
import {getFilterByKey} from "../../../store/selectors/filter.selector";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {DisplayService} from "../../../services/display.service";
import {take} from "rxjs";
Swiper.use([FreeMode]);
@UntilDestroy()
@Component({
  selector: 'brt-search-location-filter',
  templateUrl: './search-location-filter.component.html',
  styleUrls: ['./search-location-filter.component.scss']
})
export class SearchLocationFilterComponent implements OnInit {

  @Output('value-changed') valueChanged = new EventEmitter<District[]>();
  @Output('userLocationChanged') userLocationChanged = new EventEmitter<string>();
  @Output('save') onSave = new EventEmitter<District[]>();

  @Input('entity') set setEntity(val: "provider" | "job") {
    this.currentEntity = val;

    if(this.currentEntity === "provider") {
      this.distanceFilterKey = "providersDistance";
      this.districtsFilterKey = "activeProviderDistrictIds";
      this.settingsKey = "searchTermProviderLocation";
      this.userLocationFilterKey = "userLocationProvider";
    } else if(this.currentEntity === "job") {
      this.distanceFilterKey = "jobsDistance";
      this.districtsFilterKey = "activeJobDistrictIds";
      this.settingsKey = "searchTermJobLocation";
      this.userLocationFilterKey = "userLocationJob";
    }

    this.$currentDistanceValue = this.store.select(getFilterByKey(this.distanceFilterKey));

    this.store.select(getFilterByKey(this.districtsFilterKey)).pipe(untilDestroyed(this)).subscribe((newVal) => {
      this.activeDistricts = this.districtsService.districts.filter((el) => {
        return newVal.includes(el.id);
      });
      this.savedDistricts = [...this.activeDistricts];
      this.onSave.emit(this.savedDistricts);
    })
  }
  currentEntity: "provider" | "job" = "provider";
  distanceFilterKey = "";
  districtsFilterKey = "";
  settingsKey = '';
  userLocationFilterKey = "";
  districts = this.districtsService.districts;
  distanceSliderOptions: SwiperOptions = {
    freeMode: true,
    slidesPerView: "auto",
    spaceBetween: 8
  }

  googleMaps: any;
  geocodeService: any;

  activeDistricts: District[] = [];
  savedDistricts: District[] = [];
  $currentDistanceValue = this.store.select(getFilterByKey(this.distanceFilterKey)).pipe(take(1));

  isInLoadingState = false;

  constructor(private districtsService: DistrictsService, private store: Store<AppState>, private displayService: DisplayService) {
  }

  ngOnInit() {
  }

  resetFilter() {
    this.activeDistricts = [];
    this.savedDistricts = [];
    this.saveFilter();
  }
  saveFilter() {
    // this.savedDistricts = [...this.activeDistricts];
    // console.log(this.distanceFilterKey);
    // console.log(this.activeDistricts.map(el => el.id));
    this.store.dispatch(setJobFilter({key: this.districtsFilterKey, value: this.activeDistricts.map(el => el.id)}));
    this.store.select(getFilterByKey(this.distanceFilterKey)).pipe(take(1)).subscribe((currentDistance) => {
      if(currentDistance === 0) {
        this.store.dispatch(setJobFilter({key: this.distanceFilterKey, value: 30}));
      }
    })
    // this.onSave.emit(this.savedDistricts);
  }

  toggleDistrict(item: District) {
    const targetIdx = this.activeDistricts.findIndex((el) => el.id === item.id)
    if(targetIdx === -1) {
      this.activeDistricts = [...this.activeDistricts, item];
    } else {
      this.activeDistricts.splice(targetIdx, 1);
    }

    this.valueChanged.emit(this.activeDistricts);

    if(this.displayService.isMobileScreenSize()) {
      this.saveFilter();
    }
  }

  isActive(item: District) {
    return this.activeDistricts.findIndex((el) => el.id === item.id) !== -1;
  }

  getBrowserLocation() {
    if (navigator.geolocation) {
      this.isInLoadingState = true;
      navigator.geolocation.getCurrentPosition((position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        if (window?.google) {
          this.googleMaps = window.google;
          this.geocodeService = new window.google.maps.Geocoder();

          this.geocodeService.geocode({
            location: {
              lat: latitude,
              lng: longitude
            }
          }, (results: any, status: any) => {
            if (status == google.maps.GeocoderStatus.OK) {
              let locationName = "";
              results[0].address_components.forEach((addressComponent: any) => {
                if(addressComponent.types.indexOf("locality") > -1) {
                  locationName = addressComponent.long_name;
                }
              });

              if(locationName.length) {
                this.activeDistricts = [];
                this.saveFilter();
                this.userLocationChanged.emit(locationName);
                this.store.dispatch(setJobFilter({key: this.settingsKey, value: locationName}));
                this.store.dispatch(setJobFilter({key: this.userLocationFilterKey, value: {
                    lat: latitude,
                    lng: longitude
                }}));

                this.store.select(getFilterByKey(this.distanceFilterKey)).pipe(take(1)).subscribe((currentDistance) => {
                  if(currentDistance === 0) {
                    this.store.dispatch(setJobFilter({key: this.distanceFilterKey, value: 30}));
                  }
                })
              }

            } else {
              alert('Geocode was not successful for the following reason: ' + status);
            }
            this.isInLoadingState = false;


          });

        }

      });


    } else {
      console.warn("Geolocation is not supported by this browser.");
    }

  }

  setProvidersDistance(distance: number) {
    this.store.dispatch(setJobFilter({key: this.distanceFilterKey, value: distance}))
  }

  resetNotSavedDistricts() {
    this.activeDistricts = [...this.savedDistricts];
  }
}
